var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo bg-color-0 shadow-inset-1 p-2 d-flex align-center"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"w-100 d-block",attrs:{"alt":"akurata.lk logo","src":require(("@/assets/images/" + _vm.src))}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }